export class User {
  secretQuestion: string;
  secretQuestion2: string;
  secretQuestion3: string;
  secretQuestionAnswer: string;
  secretQuestionAnswer2: string;
  secretQuestionAnswer3: string;
  email: string;
  uid: string;
  userPassword: string;
  edeliveryflag: string;
}

